import React from 'react';
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';

export type ActionStatus = 'processing' | 'success' | 'error';

export interface ActionStatusDialogState {
  open: boolean;
  status: ActionStatus;
  title: string;
  message: string;
  details?: string;
}

interface ActionStatusDialogProps extends ActionStatusDialogState {
  onClose: () => void;
}

const ActionStatusDialog: React.FC<ActionStatusDialogProps> = ({
  open,
  status,
  title,
  message,
  details,
  onClose,
}) => (
  <Dialog
    open={open}
    onClose={status === 'processing' ? undefined : onClose}
    maxWidth="sm"
    fullWidth
    disableEscapeKeyDown={status === 'processing'}
  >
    <DialogTitle sx={{ pb: 1, fontWeight: 700 }}>{title}</DialogTitle>
    <DialogContent>
      {status === 'processing' ? (
        <Stack spacing={2} alignItems="center" sx={{ py: 2.5 }}>
          <CircularProgress size={38} />
          <Box textAlign="center">
            <Typography variant="body1" sx={{ fontWeight: 600 }}>{message}</Typography>
            {details && <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>{details}</Typography>}
          </Box>
        </Stack>
      ) : (
        <Alert severity={status} variant="outlined">
          <Typography variant="body2" sx={{ fontWeight: 600 }}>{message}</Typography>
          {details && <Typography variant="caption" sx={{ display: 'block', mt: 0.5 }}>{details}</Typography>}
        </Alert>
      )}
    </DialogContent>
    {status !== 'processing' && (
      <DialogActions>
        <Button variant="contained" onClick={onClose} autoFocus>OK</Button>
      </DialogActions>
    )}
  </Dialog>
);

export default ActionStatusDialog;
